import React from "react";
import columbiaLogo from "../../assetFiles/columbiaLogo.png"
import cacfLogo from "../../assetFiles/cacfLogo.jpg"
import delvebrightLogo from "../../assetFiles/delvebrightLogo.png"
import linkedinLogo from "../../assetFiles/LI-Logo.png"
import gmailLogo from "../../assetFiles/gmailLogo.png"
import githubLogo from "../../assetFiles/GitHub_Logo.png"

function LeadershipPage() {
    return (
        <div className="experience-page">
            <div style={{
                position: 'relative',
                top: '30px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '95%',   
                zIndex: 2,
                transition: 'opacity 1s ease-in',
            }}>
                <div style={{
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    border: '2px solid #333',
                    borderRadius: '15px',
                    padding: '10px',
                    boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center'
                }}>
                    <a href="/Home" style={{ color: 'white', textDecoration: 'none' }}>Home</a>
                    <a href="/Education" style={{ color: 'white', textDecoration: 'none' }}>Education</a>
                    <a href="/Experience" style={{ color: 'white', textDecoration: 'none' }}>Experience</a>
                    <a href="/Leadership" style={{ color: 'white', textDecoration: 'none' }}>Leadership</a>
                    <a href="/Projects" style={{ color: 'white', textDecoration: 'none' }}>Projects</a>
                    <a href="/Skills" style={{ color: 'white', textDecoration: 'none' }}>Skills</a>
                </div>
            </div>
            <div>
                 <h1 style={{color: 'white', marginTop: '80px'}}>Leadership</h1>
            </div>
            <div style={{position: 'relative', left: '50%', transform: 'translateX(-50%)', width: '43rem'}}>
                <div style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            border: '2px solid #333',
                            borderRadius: '15px',
                            padding: '10px',
                            boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                            zIndex: 2,
                            width: '43rem',
                            height: 'fit-content',
                            marginBottom: '2rem',
                        }}>
                    <h2 style={{color: 'white'}}>Resident Advisor {'('}Academic Year{')'}</h2>
                    <h3 style={{color: 'white'}}>Columbia University</h3>
                    <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                        <span>August 2022 - Present</span>
                        <span>New York, NY</span>
                    </div>
                    <div style={{margin: '20px 0px'}}>
                        <img style={{width: '200px', height: '200px', borderRadius: '15px', border: 'solid 1px white'}}src={columbiaLogo} alt="Columbia University Logo"></img>
                    </div>
                    <div style={{display: 'flex', alignItems: 'flex-start'}}>
                        <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                            <ul style={{fontSize: '1em', textAlign: 'left'}}>
                                <li style={{marginBottom: '5px'}}>Serves as a main point of support and contact for first-year students at Columbia University.</li>
                                <li style={{marginBottom: '5px'}}>Collaborates with three residential life organizations to host events with turnouts of over 100 students.</li>
                                <li style={{marginBottom: '5px'}}>In-dorm mentor for students studying computer science, assisting them with assignments and projects.</li>
                                <li>Supervise over 40 students ranging from first year-students to upperclass students from various special interest groups.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{position: 'relative', left: '50%', transform: 'translateX(-50%)', width: '43rem'}}>
                <div style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            border: '2px solid #333',
                            borderRadius: '15px',
                            padding: '10px',
                            boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                            zIndex: 2,
                            width: '43rem',
                            height: 'fit-content',
                            marginBottom: '2rem'
                        }}>
                    <h2 style={{color: 'white'}}>Organization Ambassador</h2>
                    <h3 style={{color: 'white'}}>Coalition for Asian American Children and Families</h3>
                    <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                        <span>June 2020 - July 2021</span>
                        <span>New York, NY</span>
                    </div>
                    <div style={{margin: '20px 0px'}}>
                        <img style={{width: '200px', height: '200px', borderRadius: '15px', border: 'solid 1px white'}}src={cacfLogo} alt="CACF Logo"></img>
                    </div>
                    <div style={{display: 'flex', alignItems: 'flex-start'}}>
                        <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                            <ul style={{fontSize: '1em', textAlign: 'left'}}>
                                <li style={{marginBottom: '5px'}}>Led a team for a language access campaign for schools across New York City.</li>
                                <li style={{marginBottom: '5px'}}>Reached out to schools and politicians in New York City to advance campaign.</li>
                                <li>Developed side projects aimed towards fundraising and recruitment processes.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{position: 'relative', left: '50%', transform: 'translateX(-50%)', width: '43rem'}}>
                <div style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            border: '2px solid #333',
                            borderRadius: '15px',
                            padding: '10px',
                            boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                            zIndex: 2,
                            width: '43rem',
                            height: 'fit-content',
                            marginBottom: '2rem',
                        }}>
                    <h2 style={{color: 'white'}}>Branch Manager</h2>
                    <h3 style={{color: 'white'}}>DelveBright Education</h3>
                    <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                        <span>June 2017 - September 2017</span>
                        <span>New York, NY</span>
                    </div>
                    <div style={{margin: '20px 0px'}}>
                        <img style={{width: '200px', height: '200px', borderRadius: '15px', border: 'solid 1px white', backgroundColor: 'white'}}src={delvebrightLogo} alt="DelveBright Logo"></img>
                    </div>
                    <div style={{display: 'flex', alignItems: 'flex-start'}}>
                        <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                            <ul style={{fontSize: '1em', textAlign: 'left'}}>
                                <li style={{marginBottom: '5px'}}>Created lessons and scheduled one-on-one tutoring session with tutors on demand.</li>
                                <li style={{marginBottom: '5px'}}>Led a branch team through summer projects to enhance learning for low-income children.</li>
                                <li style={{marginBottom: '5px'}}>Assisted parents and families with English as a second language through learning curriculums.</li>
                                <li>Managed tutor time schedules, weekly attendance, and student assignments.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{
                        position: 'relative',
                        bottom: '10px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '95%',
                        zIndex: 2,
                    }}>
                    <div style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            border: '2px solid #333',
                            borderRadius: '15px',
                            padding: '10px',
                            boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                        <span style={{ color: 'white' }}>© 2024 Steven Huang | Product Manager & Developer | v1.2 | stevenhuangtech@gmail.com</span>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center'  // This ensures vertical centering of the buttons
                            }}>
                            <span style={{ color: 'white'}}>Interested? Feel free to contact me! ---{'>'} </span>
                            <a 
                                href="mailto:stevenhuangtech@gmail.com" 
                                style={{
                                backgroundColor: 'white',
                                border: 'none',
                                padding: '5px',
                                margin: '0 5px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '20px',
                                height: '20px',
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.opacity = 0.7}
                                onMouseLeave={(e) => e.currentTarget.style.opacity = 1}
                                >
                                <img 
                                    src={gmailLogo}
                                    alt="Email"
                                    style={{
                                        width: '20px',
                                        height: '20px'
                                    }}
                                />
                            </a>
                            <a 
                                href="https://github.com/huangs-nyc" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{
                                backgroundColor: 'white',
                                border: 'none',
                                padding: '5px',
                                margin: '0 5px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '70px',
                                height: '20px'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.opacity = 0.9}
                                onMouseLeave={(e) => e.currentTarget.style.opacity = 1}
                                >
                                <img 
                                    src={githubLogo} 
                                    alt="Github"
                                    style={{
                                    width: '50px',
                                    height: '20px'
                                    }}
                                />
                            </a>
                            <a 
                                href="https://www.linkedin.com/in/steven-huang-a60a8a22a/" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{
                                backgroundColor: 'white',
                                border: 'none',
                                padding: '5px',
                                margin: '0 5px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100px',
                                height: '20px'
                            }}
                                onMouseEnter={(e) => e.currentTarget.style.opacity = 0.9}
                                onMouseLeave={(e) => e.currentTarget.style.opacity = 1}
                            >
                            <img 
                                src={linkedinLogo} 
                                alt="LinkedIn"
                                style={{
                                width: '80px',
                                height: '20px'
                                }}
                            />
                            </a>
                        </div>
                    </div>
            </div>
        </div>
    )
}

export default LeadershipPage